import { render, staticRenderFns } from "./SelectStatusProjeto.vue?vue&type=template&id=6e9c2b20&scoped=true"
import script from "./SelectStatusProjeto.vue?vue&type=script&lang=js"
export * from "./SelectStatusProjeto.vue?vue&type=script&lang=js"
import style0 from "./SelectStatusProjeto.vue?vue&type=style&index=0&id=6e9c2b20&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c2b20",
  null
  
)

export default component.exports